import IterableDataProcessor from "../../entities/IterableDataProcessor.js";
import { ResultData } from "../../enums/index.js";
import ResultFormatterBase from "../ResultFormatterBase.js";

class DefaultValuesFormatter extends ResultFormatterBase {
    constructor(dataParameter, path, breakOnFirstReplacement) {
        if (!(dataParameter instanceof Object)) {
            throw new TypeError('dataParameter must be an object');
        }

        if (!dataParameter.hasOwnProperty('key')) {
            throw new TypeError('dataParameter must have an "key" property');
        }

        super();

        if (typeof(breakOnFirstReplacement) === 'undefined') {
            this.breakOnFirstReplacement = true;
        }
        else if (typeof(breakOnFirstReplacement) !== 'boolean') {
            throw new TypeError('breakOnFirstReplacement must be undefined or boolean type');
        }
        else {
            this.breakOnFirstReplacement = breakOnFirstReplacement;
        }

        if (typeof(path) !== 'undefined' && !(path instanceof Array)) {
            throw new TypeError('path must be undefined or array');
        }

        this.dataParameter = dataParameter;
        this.replacements = [];
        this.path = (path || [ResultData.Data.key]).concat([this.dataParameter.key]);
    }

    registerReplacement(source, replacement) {
        this.replacements.push(
            { source, replacement }
        );

        return this;
    }

    format(result) {
        if (!result) {
            return result;
        }

        for (let i = 0; i < this.replacements.length; i++) {
            const replacement = this.replacements[i];
            const value = IterableDataProcessor.getObjectContent(result, this.path);

            if (value === replacement.source) {
                if (
                    IterableDataProcessor.setObjectContent(result, this.path, replacement.replacement)
                    && this.breakOnFirstReplacement
                ) {
                    break;
                }
            }
        }

        return result;
    }
}

export default DefaultValuesFormatter;